// extracted by mini-css-extract-plugin
export default {"container":"customers_list_container__KRvib"};